import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import { Container, Col, CardText } from "reactstrap";
import styled from "styled-components";
import { Link } from "react-router-dom";
import mailLogo from "../icons/Post.png";
import teleLogo from "../icons/Telefon.png";
import faxLogo from "../icons/Fax.png";

class Footer extends Component {
  render() {
    console.log(this.props);
    return (
      <Wrapper>
        <Container>
          <JRow>
            <JCol>
              <JCardText>
                GLOCK & Partner
                <br />
                Notar, Rechtsanwälte, Steuerberater
              </JCardText>
              <JCardText>
                Kaiserstraße 6A <br />
                65385 Rüdesheim am Rhein
              </JCardText>
              <JCardText>
                <img alt="" height={30} src={teleLogo} />
                +49 (0) 6722 500-0
                <br />
                <img alt="" height={30} src={faxLogo} />
                +49 (0) 6722 500-500
                <br />
                <img alt="" height={30} src={mailLogo} />
                mail@glock-partner.de
              </JCardText>
            </JCol>
            <JCol>
              <JCardText>M · L · G Steuerberatung</JCardText>
              <JCardText>
                Kaiserstraße 6A <br />
                65385 Rüdesheim am Rhein
              </JCardText>
              <JCardText>
                <img alt="" height={30} src={teleLogo} />
                +49 (0) 6722 500-200
                <br />
                <img alt="" height={30} src={faxLogo} />
                +49 (0) 6722 500-520
                <br />
                <img alt="" height={30} src={mailLogo} />
                info@m-l-g.de
              </JCardText>
            </JCol>
            <JCol>
              <JCardText>
                B · I · T<br />
                Wirtschaftsberatung GmbH
              </JCardText>
              <JCardText>
                Kaiserstraße 6A <br />
                65385 Rüdesheim am Rhein
              </JCardText>
              <JCardText>
                <img alt="" height={30} src={teleLogo} />
                +49 (0) 6722 500-300
                <br />
                <img alt="" height={30} src={faxLogo} />
                +49 (0) 6722 500-390
                <br />
                <img alt="" height={30} src={mailLogo} />
                info@bit-wb.de
              </JCardText>
            </JCol>
          </JRow>
          <JRow>
            <JCol>
              <JLink
                to={this.props.location.pathname !== "/" && "/"}
                onClick={() => this.loadTop()}
              >
                <h5>Partner</h5>
              </JLink>
              <JLink
                to={
                  this.props.location.pathname !== "/Impressum" && "/Impressum"
                }
                onClick={() => this.loadTop()}
              >
                <h5>Impressum / Datenschutzerklärung</h5>
              </JLink>
            </JCol>
          </JRow>
        </Container>

        <BuildBy>
          <JLink to="">Design & Build: JJ</JLink>
        </BuildBy>
      </Wrapper>
    );
  }

  loadTop() {
    var top = (document.getElementById("root").scrollTo =
      0 || window.scrollTo(0, 0));
    this.setState({
      i: top
    });
  }
}

const JCardText = styled(CardText)`
  font-size: 14px !important;
`;

const Wrapper = styled.div`
  background-color: #ddd;
  margin-bottom: -7px;
  @media only screen and (min-device-width: 320px) and (max-device-width: 480px) and (-webkit-min-device-pixel-ratio: 2) and (orientation: portrait) {
    margin-bottom: -10px;
  }
`;

const JRow = styled.div`
  display: flex;
  display: -ms-flexbox;
  flex-direction: row;

  -ms-flex-direction: row;
  flex-wrap: wrap;
  flex-flow: center;
  justify-content: center;
  padding: 2rem;
  @media only screen and (max-width: 800px) {
    flex-direction: column;
    -ms-flex-direction: row;
  }
`;

const JCol = styled(Col)`
  display: block;
  padding: 2rem;
  min-width: 300px;
`;

const BuildBy = styled(Col)`
  padding: 2rem;
  text-align: center;
`;

const JLink = styled(Link)`
  color: #000;
  :hover {
    color: #555;
    text-decoration: none;
  }
`;

export default withRouter(Footer);
